import { render, staticRenderFns } from "./Clause.vue?vue&type=template&id=2d4d5aa1&scoped=true&"
import script from "./Clause.vue?vue&type=script&lang=js&"
export * from "./Clause.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4d5aa1",
  null
  
)

export default component.exports